import { createContext, useContext } from 'react';
/**
 * `true` below a kit `Table`. Read by `StatusTag` and `DisabledReason`: a
 * hinted status chip or a blocked control's wrapper is a tab stop on a page,
 * but in a table cell it is not — fifty rows would be fifty stops, and the
 * row (its drawer, its tag) carries the same information. The explanation
 * stays the element's `aria-description`, and a tap still pins it, either way.
 */
export const InTableContext = createContext(false);
export function useInTable() {
    return useContext(InTableContext);
}
//# sourceMappingURL=in-table-context.js.map